import { AccountService } from 'src/app/services/account/account.service';
import { OnlineService } from 'src/app/services/general/online.service';

import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Platform, ModalController, IonInput } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

// import { NativeAudio } from '@capacitor-community/native-audio';
// import { BarcodeScanner, ScanResult } from '@capacitor-community/barcode-scanner';

import {
  BarcodeScanner,
  LensFacing,
  // BarcodeFormat,
  // LensFacing,
  // ScanResult,
} from '@capacitor-mlkit/barcode-scanning';

import { ModuleService } from 'src/app/services/account/privilege/module.service';
import { GuestService } from 'src/app/services/guest/guest.service';
import { GroupService } from 'src/app/services/group/group.service';
import { CheckinSettingService } from 'src/app/services/checkin/checkin-setting.service';
import { PopupService } from 'src/app/services/general/popup.service';
import { ErrorService } from 'src/app/services/general/error.service';

import { GuestGroupComponent } from 'src/app/components/group/guest-group/guest-group.component';
import { CheckinProfileComponent } from 'src/app/components/checkin/checkin-profile/checkin-profile.component';

import { Guest } from 'src/app/interfaces/guest';
import { Group } from 'src/app/interfaces/group';
import { AccountInfo, UserAccounts } from 'src/app/interfaces/account';
import { AccountLogin, LoginUrl } from 'src/app/interfaces/login';

import { ModuleType, ScanQrcodeType } from 'src/app/types/general';
import { DynamicUrl, GuideScanGuestUrl } from 'src/app/commons/url';
import { LanguageService } from 'src/app/services/general/language.service';
import { LinkService } from 'src/app/services/general/link.service';
import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { BarcodeScannerService } from 'src/app/services/general/barcode-scanner.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { FunctionService } from 'src/app/services/general/function.service';

/**
 * Scan QR code component
 */
@Component({
  selector: 'app-scan-qrcode',
  templateUrl: './scan-qrcode.component.html',
  styleUrls: ['./scan-qrcode.component.scss'],
})
export class ScanQrcodeComponent implements OnInit, OnDestroy {
  
  @ViewChild('header', { read: ElementRef, static: false }) header: ElementRef;

  @ViewChild('input', { static: false }) input: IonInput;
  /**
   * page mode
   */
  @Input() pageMode: boolean;
  /**
   * Show back button else show menu button
   */
  @Input() showBackButton: boolean;
  /**
   * Scan QR code type
   */
  @Input() type: ScanQrcodeType;
  /**
   * Reset scan state
   */
  @Input() set reset(flag: boolean) {
    if (flag) {
      this.initialize();
    } else {
      this.stop();
    }
  }

  /**
   * Back action
   */
  @Output() back = new EventEmitter<boolean>();

  /**
   * AccountModule
   */
  module: ModuleType;
  /**
   * Camera ready
   */
  ready: boolean;

  contentHeight: string;

  isHybrid: boolean;

  scanMode: string;

  torchEnabled: boolean;
  torchAvailable: boolean;
  lensFacing: any;

  autoFocus: boolean;

  private isInputFocused: boolean = false;

  private unlistenFocus: () => void;
  private unlistenBlur: () => void;

  validationMsg: any;

  timeout: NodeJS.Timeout | string | number | undefined;

  form: FormGroup;

  /**
   * Constructor
   * @param platform platform
   * @param router router
   * @param modalController modal controller
   * @param translate translate service
   * @param moduleService module service
   * @param guestService guest service
   * @param groupService group service
   * @param checkinSettingService checkin setting service
   * @param popupService popup service
   */
  constructor(
    private ngZone: NgZone,
    private renderer: Renderer2,
    private platform: Platform,
    private router: Router,
    private formBuilder: FormBuilder,
    private modalController: ModalController,
    private fns: AngularFireFunctions,
    private translate: TranslateService,
    private moduleService: ModuleService,
    private guestService: GuestService,
    private groupService: GroupService,
    private accountService: AccountService,
    private accountsListService: AccountsListService,
    private checkinSettingService: CheckinSettingService,
    private barcodeScannerService: BarcodeScannerService,
    private languageService: LanguageService,
    private linkService: LinkService,
    private onlineService: OnlineService,
    private popupService: PopupService,
    private errorService: ErrorService,
    private functionService: FunctionService,
  ) {
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.stop();
    this.stopTimeout();
  }

  /**
   * Before view enter
   */
  ionViewWillEnter() {
    this.initialize();
  }

  /**
   * Before view leave
   */
  async ionViewWillLeave() {
    this.stop();
    this.stopTimeout();
  }
  

  /**
   * Initialize
   */
  async initialize() {
    await this.platform.ready();

    this.ready = false;
    this.isHybrid = this.platform.is('hybrid');
    this.scanMode = 'camera';

    if (!this.module) {
      this.module = this.moduleService.currentModule;
    }
    this.setupContentHeight();
    if (this.platform.is('hybrid')) {
      await this.popupService.presentLoading();
      
      this.torchEnabled = await this.checkTorchEnable();
      this.torchAvailable = await this.checkTorchAvailable();

      this.lensFacing = 'BACK';
      
      // await BarcodeScanner.prepare();
      // await BarcodeScanner.hideBackground();
      await this.setupSound();
      // await Keyboard.setResizeMode({ mode: KeyboardResize.None });
      this.scan();
    } else {
      if (this.type === 'checkin') {
        this.scanMode = 'scanner';
        this.setupForm();
      }
    }
    // const data: any = { groupId: '12323'};
    // const group: Group = data;
    // this.presentGroupModal(group);
  }

  async setupContentHeight() {
    await this.functionService.delay(300);
    const header = this.getHeaderHeight();
    if (header) {
      this.contentHeight = 'calc(100vh - ' + header + 'px)';
      // if (this.scanMode === 'scanner') {
      //   if (this.isHybrid) {
      //     this.contentHeight = 'calc(100vh - 44px - 51px - 61px)';
      //   } else {
      //     this.contentHeight = 'calc(100vh - 44px - 51px)';
      //   }
      // } else {
        
      // }
    } else {
      this.setupContentHeight();
    }
  }

  getHeaderHeight() {
    let header = 0;
    if (this.pageMode) {
      if (this.header?.nativeElement?.offsetHeight) {
        header = this.header.nativeElement.offsetHeight;
      }
    }
    return header;
  }

  async stop() {
    if (this.platform.is('hybrid')) {
      // await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
      this.unloadSound();
      await this.barcodeScannerService.stopScan();
    }
  }

  /**
   * Stop scanning
   */
  async stopScan() {
    // document.querySelector('body')?.classList.remove('barcode-scanner-active');
    // await this.barcodeScannerService.stopScan();
    // if (BarcodeScanner) {
    //   try {
    //     BarcodeScanner?.stopScan();
    //     BarcodeScanner?.showBackground();
    //   } catch (err) {
    //     this.errorService.logError(err);
    //   }
    // }
  }

  /**
   * Setup Sound
   * Platform: Android/iOS
   * This method will load short duration audio file into memory.
   * @param assetPath - relative path of the file or absolute url (http://)
   * @param assetId - unique identifier of the file
   * @returns void
   */
  async setupSound() {
    if (this.platform.is('hybrid')) {
      // await NativeAudio.preload({
      //   assetPath: 'public/assets/wedding/sound/beep.wav',
      //   assetId: 'beep'
      // }).catch((err: any) => {
      //   this.errorService.logError(err);
      // });
    }
  }

  /**
   * Unload sound from memory
   */
  async unloadSound() {
    // await NativeAudio.unload({
    //   assetId: 'beep',
    // }).catch((err: any) => {
    //   this.errorService.logError(err);
    // });
  }

  /**
   * Play sound
   */
  async playSound() {
    if (this.platform.is('hybrid')) {
      if (this.module !== 'checkin' || this.checkinSettingService?.checkinSetting?.scanSound) {
        const audio = new Audio('./assets/wedding/sound/beep.wav');
        audio.play();
        // NativeAudio.play({
        //   assetId: 'beep', time: 0.0
        // });
      }
    }
  }

  async checkTorchEnable() {
    const { enabled } = await BarcodeScanner.isTorchEnabled();
    return enabled;
  }

  async checkTorchAvailable() {
    const { available } = await BarcodeScanner.isTorchAvailable();
    return available;
  }

  async toggleCamera() {
    if (this.lensFacing === 'FRONT') {
      this.lensFacing = 'BACK';
    } else {
      this.lensFacing = 'FRONT';
    }
  }

  async toggleTorch(torchEnabled: boolean) {
    this.torchEnabled = !torchEnabled;
    if (this.torchEnabled) {
      await BarcodeScanner.enableTorch();
    } else {
      await BarcodeScanner.disableTorch();
    }
  }

  async didUserGrantPermission() {
    const status = await BarcodeScanner.checkPermissions();
    if (status?.camera) {
      if (status.camera === 'granted') {
        // user granted permission
        return true;
      } else if (status.camera === 'denied' || status.camera === 'prompt-with-rationale' || status.camera === 'limited') {
        // user denied permission
        this.promptPermissionSetting();
        return false;
      } else if (status.camera === 'prompt') {
        
      } 
    }
    
    const requestStatus = await BarcodeScanner.requestPermissions();
    if (requestStatus?.camera) {
      if (requestStatus.camera === 'granted') {
        return true;
      } else {
        this.promptPermissionSetting();
        return false;
      }
    }

    // if (status.restricted || status.unknown) {
    //   // ios only
    //   // probably means the permission has been denied
    //   this.promptPermissionSetting();
    //   return false;
    // }

    // user has not denied permission
    // but the user also has not yet granted the permission
    // so request it
    const statusRequest = await BarcodeScanner.checkPermissions();


    // if (statusRequest.camera === 'granted') {
    //   // the user did grant the permission now
    //   return true;
    // } else {
    //   this.promptPermissionSetting();
    // }

    // if (statusRequest.asked) {
    //   // system requested the user for permission during this call
    //   // only possible when force set to true
    // }

    // if (statusRequest.granted) {
    //   // the user did grant the permission now
    //   return true;
    // } else {
    //   this.promptPermissionSetting();
    // }

    // user did not grant the permission, so he must have declined the request
    return false;
  }

  watchGoogleBarcodeModuleInstallation() {
    const listener = BarcodeScanner.addListener(
      'googleBarcodeScannerModuleInstallProgress', 
      async result => {
        if (result?.progress === 100) {
          this.scan();
        }
      },
    );
  }

  /**
   * Scan QR code
   */
  async scan() {
    if (this.platform.is('hybrid')) {
      if (await this.didUserGrantPermission()) {
        try {
          if (this.platform.is('android')) {
            const { available } = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
            if (!available) {
              await BarcodeScanner.installGoogleBarcodeScannerModule();
              this.watchGoogleBarcodeModuleInstallation();
              return false;
            } 
          }
          this.ready = true;
          await this.popupService.dismissLoading();
          
          // The camera is visible behind the WebView, so that you can customize the UI in the WebView.
          // However, this means that you have to hide all elements that should not be visible.
          // You can find an example in our demo repository.
          // In this case we set a class `barcode-scanner-active`, which then contains certain CSS rules for our app.
          // document.querySelector('body')?.classList.add('barcode-scanner-active');

          // Add the `barcodeScanned` listener
          const listener = await BarcodeScanner.addListener(
            'barcodeScanned',
            async result => {
              this.barcodeScannerService.stopScan();
              if (result?.barcode?.displayValue) {
                await this.checkQrCode(result.barcode.displayValue);
              } else {
                await this.invalidCode();
                // await this.popupService.dismissLoading();
              }
            },
          );

          // Start the barcode scanner
          await BarcodeScanner.startScan({ lensFacing: this.lensFacing });


          // const result: ScanResult = await BarcodeScanner.startScan();
          // this.playSound();
          // if (result.hasContent) {
          //   this.checkQrCode(result.content);
          // } else {
          //   this.popupService.dismissLoading();
          // }
        } catch (err: any) {
          this.errorService.logError(err);
          this.popupService.dismissLoading();
        }
      }
    }
  }

  /**
   * Check QR Code
   * @param qrcode QR Code
   */
  async checkQrCode(qrcode: string) {
    if (qrcode) {
      // await BarcodeScanner.stopScan();
      if (this.ready) {
        await this.popupService.presentLoading();
        if (this.type === 'accounts') {
          await this.checkAccountQrcode(qrcode);
        } else if (this.type === 'checkin') {
          await this.checkGuest(qrcode);
        } else {
          await this.invalidCode();
        }
      }
    } else {
      await this.invalidCode();
    }
  }

  /**
   * Check account QR Code for Gift card / account login
   * @param qrcode QR code
   */
  async checkAccountQrcode(qrcode: string) {
    const url = DynamicUrl.long.login;
    const url2 = DynamicUrl.long.login2;
    if (qrcode?.indexOf(url) !== -1) {
      const text = qrcode.replace(url, '');
      try {
        const decoded = decodeURI(text).replace(/%2F/g, '/');
        const loginUrl: LoginUrl = JSON.parse(decoded);
        if (loginUrl?.login?.weddingId && loginUrl?.login?.weddingPass && loginUrl?.timestamp) {
          if (loginUrl?.title && loginUrl?.time && loginUrl?.role?.type && loginUrl?.utc) {
            this.goAccountLoginPreviewPage(loginUrl);
          } else {
            this.getAccountLoginPreviewCall(loginUrl);
          }
        } else {
          this.invalidCode();
        }
      } catch (err) {
        this.invalidCode();
      }
    } else if (qrcode?.indexOf(url2) !== -1) {
      const text = qrcode.replace(url2, '');
      try {
        const decoded = decodeURI(text).replace(/%2F/g, '/');
        const loginUrl: LoginUrl = JSON.parse(decoded);
        if (loginUrl?.login?.weddingId && loginUrl?.login?.weddingPass && loginUrl?.timestamp) {
          if (loginUrl?.title && loginUrl?.time && loginUrl?.role?.type && loginUrl?.utc) {
            this.goAccountLoginPreviewPage(loginUrl);
          } else {
            this.getAccountLoginPreviewCall(loginUrl);
          }
        } else {
          this.invalidCode();
        }
      } catch (err) {
        this.invalidCode();
      }
    } else if (qrcode?.indexOf(DynamicUrl.long.gift) !== -1) {
      const giftCardId = qrcode.replace(DynamicUrl.long.gift, '');
      this.goGiftCardPage(giftCardId);
    } else if (qrcode?.indexOf(DynamicUrl.long.gift2) !== -1) {
      const giftCardId = qrcode.replace(DynamicUrl.long.gift2, '');
      this.goGiftCardPage(giftCardId);
    } else if (qrcode && (qrcode?.indexOf(DynamicUrl.long.visitor) !== -1 || qrcode?.indexOf(DynamicUrl.long.visitor2) !== -1 || qrcode?.indexOf(DynamicUrl.long.visitor3) !== -1 || qrcode?.indexOf(DynamicUrl.long.visitor4) !== -1)) {
      this.invalidType('checkin',  qrcode)
    } else {
      this.invalidCode();
    }
  }

  /**
   * Check guest QR code
   * @param qrcode QR code
   */
  async checkGuest(qrcode: string) {
    let valid = false;
    if (qrcode.indexOf(DynamicUrl.long.guestWeb) !== -1 || qrcode.indexOf(DynamicUrl.long.guestWeb2) !== -1) {
      const param = qrcode?.replace(DynamicUrl.long.guestWeb, '')?.replace(DynamicUrl.long.guestWeb2, '');
      const decode = param?.split('/');

      const accountId: string = decode?.[0];
      const linkId: string = decode?.[1];
      const guestId: string = decode?.[2];
      const groupId: string = decode?.[3];

      if (accountId === this.accountService.accountId) {
        // URL qrcode
        if (groupId && guestId && guestId !== '0') {
          const guest: Guest = this.guestService.checkGuestQrcode(guestId);
          if (guest) {
            valid = true;
            await this.presentCheckinProfileModal(guest);
          }
        } else if (guestId === '0' && groupId) {
          const group: Group = this.groupService.getGroupByQrcode(groupId);
          if (group?.groupId) {
            valid = true;
            await this.presentGroupModal(group);
          }
        } else if (guestId && guestId !== '0') {
          const guest: Guest = this.guestService.checkGuestQrcode(guestId);
          if (guest) {
            valid = true;
            await this.presentCheckinProfileModal(guest);
          }
        }
      } else if (qrcode) {
        // Custom QR code
        const guest: Guest = this.guestService.checkGuestQrcode(qrcode);
        if (guest) {
          valid = true;
          await this.presentCheckinProfileModal(guest);
        } else {
          const group: Group = this.groupService.getGroupByQrcode(qrcode);
          if (group) {
            valid = true;
            await this.presentGroupModal(group);
          }
        }
      }
    } else {
      const param = qrcode?.replace(DynamicUrl.long.visitor, '')?.replace(DynamicUrl.long.visitor2, '')?.replace(DynamicUrl.long.visitor3, '')?.replace(DynamicUrl.long.visitor4, '');
      const decode = param?.split('/');
      const accountId: string = decode?.[0];
      const guestId: string = decode?.[1];
      const groupId: string = decode?.[2];
      
      if (accountId === this.accountService.accountId) {
        // URL qrcode
        if (guestId === '0' && groupId) {
          const group: Group = this.groupService.getGroupByQrcode(groupId);
          if (group?.groupId) {
            valid = true;
            await this.presentGroupModal(group);
          }
        } else if (guestId && guestId !== '0') {
          const guest: Guest = this.guestService.checkGuestQrcode(guestId);
          if (guest) {
            valid = true;
            await this.presentCheckinProfileModal(guest);
          }
        }
      } else if (qrcode) {
        // Custom QR code
        const guest: Guest = this.guestService.checkGuestQrcode(qrcode);
        if (guest) {
          valid = true;
          await this.presentCheckinProfileModal(guest);
        } else {
          const group: Group = this.groupService.getGroupByQrcode(qrcode);
          if (group) {
            valid = true;
            await this.presentGroupModal(group);
          }
        }
      }
    }
    
    if (!valid) {
      if (qrcode && (qrcode?.indexOf(DynamicUrl.long.login) !== -1 || qrcode?.indexOf(DynamicUrl.long.login2) !== -1)) {
        this.invalidType('accounts', qrcode);
      } else {
        await this.invalidCode();
      }
    }
  }

  /**
   * Get account login preview call
   * @param loginUrl login url
   */
  async getAccountLoginPreviewCall(loginUrl: LoginUrl) {
    if (this.onlineService.isOnline()) {
      if (loginUrl) {
        await this.popupService.presentLoading();
        await this.fns.httpsCallable('getAccountLoginPreviewCall')({ loginUrl })
        .toPromise().then(async (result: any) => {
          const accountInfo: AccountInfo = result?.accountInfo;
          const accountLogin: AccountLogin = result?.accountLogin;
          if (accountInfo?.accountId && accountLogin?.accountId) {
            loginUrl.accountId = accountInfo.accountId;
            loginUrl.title = accountInfo?.title?.value;
            loginUrl.time = accountInfo?.time?._seconds ? {
              seconds: accountInfo.time._seconds, nanoseconds: accountInfo.time._nanoseconds
            } : accountInfo?.time?.seconds;
            loginUrl.utc = accountInfo?.timezone?.utc;
            loginUrl.venue = accountInfo?.location?.name;
            loginUrl.role = accountLogin?.role;
            loginUrl.anonymous = accountLogin?.role?.coupleId > 0 || accountLogin?.isOwner ? false : true;
            this.goAccountLoginPreviewPage(loginUrl, result.accountLogin);
          } else {
            this.invalidCode();
          }
        }).catch((err: any) => {
          this.invalidCode();
          this.errorService.logError(err);
        });
        this.popupService.dismissLoading();
      } else {
        this.invalidCode();
      }
    }
  }

  /**
   * Go account login preview page
   * @param loginUrl login url
   * @param accountLogin account login
   */
  goAccountLoginPreviewPage(loginUrl: LoginUrl, accountLogin?: AccountLogin) {
    const navigationExtras: NavigationExtras = {
      state: {
        loginUrl,
        accountLogin,
        loginMethod: 'qrcode'
      }
    };
    this.popupService.dismissLoading();
    this.router.navigate(['/accounts/preview-login'], navigationExtras);
  }

  /**
   * Dismiss scan QR code modal
   */
  async dismissScanQrcodeModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) {
        this.modalController.dismiss();
      }
    }
  }

  /**
   * Present guest profile modal
   * @param guest guest
   */
  async presentCheckinProfileModal(guest: Guest) {
    if (guest?.guestId) {
      const modal = await this.modalController.create({
        component: CheckinProfileComponent,
        cssClass: 'modal-full-screen-bk',
        componentProps: {
          guest,
          checkinMethod: 'scan',
        }
      });
      this.ngZone.run(async () => {
        // setTimeout(async () => {
          await this.popupService.dismissLoading();
          modal.present();
          modal.onWillDismiss().then(() => {
            this.ready = false;
            if (this.scanMode === 'scanner') {
              this.form.controls.scannerResult.setValue('');
              this.setFocus();
            } else {
              this.scan();
            }
          });
        // }, 0);
      });
    } else {
      this.popupService.presentActionError();
    }
  }

  /**
   * Present group modal
   * @param group group
   */
  async presentGroupModal(group: Group) {
    if (group?.groupId) {
      const modal = await this.modalController.create({
        component: GuestGroupComponent,
        cssClass: 'modal-full-screen-bk',
        componentProps: {
          group,
          checkinMethod: 'scan',
        }
      });
      this.ngZone.run(async () => {
        // setTimeout(async () => {
          await this.popupService.dismissLoading();
          modal.present();
          modal.onWillDismiss().then(() => {
            this.ready = false;
            if (this.scanMode === 'scanner') {
              this.form.controls.scannerResult.setValue('');
              this.setFocus();
            } else {
              this.scan();
            }
          });
          // this.platform.is('ios') ? 200 : 0
        // }, 0);
      });
    } else {
      this.popupService.presentActionError();
    }
  }

  /**
   * Invalid QR code prompt
   */
  async invalidCode() {
    await this.popupService.dismissLoading();
    if (this.scanMode === 'scanner') {
      const msg = this.translate.instant('SCAN.scanner.invalid');
      const toast = await this.popupService.presentToast(msg, 'danger', true, 2000, 'bottom');
      this.setFocus();
      toast.onWillDismiss().then(() => {
        this.ready = false;
        this.form.controls.scannerResult.setValue('');
        this.setFocus();
      });
    } else {
      const msg = this.translate.instant('SCAN.msg.invalid');
      const modal = await this.popupService.presentConfirm(msg);
      modal.onWillDismiss().then((result: any) => {
        this.ready = false;
        if (result?.data?.confirm) {
          this.scan();
        } else {
          this.goBack();
        }
      });
    }
  }

  async invalidType(type: ScanQrcodeType, qrcode: string) {
    const msg = this.translate.instant('SCAN.msg.wrong_type.' + type);
    const modal = await this.popupService.presentConfirm(msg, '', '', '', this.translate.instant('BTN.go'), this.translate.instant('BTN.back'));
    modal.onDidDismiss().then(async (result: any) => {
      this.ready = false;
      if (result?.data?.confirm) {
        if (type === 'accounts') {
          this.router.navigate(['//tabs-accounts/list/true']);
          if (!this.pageMode) {
            this.dismissScanQrcodeModal();
          }
        } else if (type === 'checkin') {
          let goGuide = true;
          if (qrcode) {
            const param = qrcode?.replace(DynamicUrl.long.visitor, '')?.replace(DynamicUrl.long.visitor2, '')?.replace(DynamicUrl.long.visitor3, '')?.replace(DynamicUrl.long.visitor4, '');
            const decode = param?.split('/');
            const accountId: string = decode?.[0];
            const guestId: string = decode?.[1];
            const groupId: string = decode?.[2];
            if (accountId) {
              if (guestId || groupId) {
                const accountList: UserAccounts[] = this.accountsListService.userAccountsList;
                const index = accountList.findIndex((x: UserAccounts) => {
                  return x.accountId === accountId && x.enable;
                });
                if (index !== -1) {
                  const currentAccountId = await this.accountService.readAccountId();
                  if (currentAccountId && currentAccountId !== accountId) {
                    await this.accountService.logoutAccount();
                  }
                  await this.accountService.loginAccount(accountId, false, true);
                  goGuide = false;
                }
              }
            }
          }
          if (goGuide) {
            const language = this.languageService.getUserLanguage().code;
            if (language === 'zh' || language === 'zh-TW') {
              await this.linkService.openUrl(GuideScanGuestUrl['zh-TW']);
            } else {
              await this.linkService.openUrl(GuideScanGuestUrl.en);
            }
            this.goBack();
          }
        }
      } else {
        this.goBack();
      }
    });
  }

  /**
   * Prompt permission setting
   */
  async promptPermissionSetting() {
    const modal = await this.popupService.presentConfirm(
      this.translate.instant('ACCOUNTS.msg.permission_setting')
    );
    modal.onDidDismiss().then(async (result: any) => {
      if (result?.data?.confirm) {
        await this.popupService.presentLoading();
        // await BarcodeScanner.openAppSettings();
        await BarcodeScanner.openSettings();
      }
      this.goBack();
      this.popupService.dismissLoading();
    });
  }

  /**
   * Go back
   */
  goBack() {
    if (this.pageMode) {
      this.back.next(true);
    } else {
      this.dismissScanQrcodeModal();
    }
  }

  /**
   * Go gift card page
   * @param giftCardId gift card id
   */
  goGiftCardPage(giftCardId: string) {
    if (giftCardId) {
      this.router.navigate(['/links/gift/' + giftCardId]);
      this.popupService.dismissLoading();
    } else {
      this.popupService.presentActionError();
    }
  }

  // closeKeyboard(event: any) {
  //   if (this.platform.is('hybrid')) {
  //     if (event?.key === 'Enter') {
  //       this.keyboardService.hide();
  //     }
  //   }
  // }

  async setupForm() {
    this.form = this.formBuilder.group({
      scannerResult: new FormControl('', [ Validators.required ]),
    });

    this.validationMsg = {
      scannerResult: [{ type: 'required', msg: this.translate.instant('VALIDATION.required', { field: this.translate.instant('ACCOUNT.lbl.wedding_id') }) }]
    };
    this.setFocus();
  }

  async modeChanged() {
    await this.popupService.presentLoading();
    await this.stopTimeout();
    this.ready = false;

    if (this.scanMode === 'scanner') {
      await this.setupForm();  
      if (this.isHybrid) {
        await this.stop();
      }
    } else {
      await this.scan();
    }
    await this.popupService.dismissLoading();
  }

  toggleAutoFocus(autoFocus: boolean) {
    this.autoFocus = !autoFocus;
    if (this.autoFocus) {
      this.input.autofocus = true;
      this.setFocus();
    } else {
      this.input.autofocus = false;
    }
  }

  setFocus() {
    if (this.input && !this.ready) {
      if (this.autoFocus) {
        this.input.setFocus();
      }
    } else {
      this.stopTimeout();

      this.timeout = setTimeout(() => {
        this.setFocus();
      }, 100);
    }
  }

  async stopTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  formSubmit() {
    this.form.markAllAsTouched();
    if (this.form.value.scannerResult && !this.ready) {
      this.ready = true;
      const qrcode = this.form.value.scannerResult;
      this.checkQrCode(qrcode);
      this.form.controls.scannerResult.setValue('');
    }
    // this.form.markAllAsTouched();
    // if (this.form.valid && this.form.value.scannerResult) {
    //   this.checkQrCode(this.form.value.scannerResult);
    // }
  }

}
